<template>
  <b-container v-if="this.type" fluid>
    <h1 v-if="title !== false">{{title || $appConfig.models[this.type].title}}</h1>
    <h4 v-translate>Realtime changes</h4>
    <b-row>
      <b-col md="12" class="col">
        <b-form-group horizontal :label="$gettext('Per page')" :label-cols="9" class="float-right mb-0">
          <b-form-select :options="pageOptions" v-model="perPage" @change="onFiltered" />
        </b-form-group>
      </b-col>
    </b-row>
    <br />

    <b-table
      :id="type"
      stacked="md"
      foot-clone
      :total-rows="totalRows"
      :sort-desc="sortDesc"
      :sort-by="sortBy"
      :per-page="perPage"
      :current-page="currentPage"
      :busy.sync="isBusy"
      :items="myProvider"
      :fields="fields"
      :api-url="this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint"
      :filter="applyFilter()"
      @filtered="onFiltered"
      @sort-changed="onFiltered"
    >
      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong v-translate>Loading...</strong>
      </div>

      <template v-for="(field, index) in fields" v-slot:cell()="row">
        <b-form-checkbox
          v-bind:key="index"
          v-model="row.item[row.field.key]"
          @change="setVehicleCapacity({size: row.item, vehicle: row.field}, $event)"
        ></b-form-checkbox>
      </template>

      <template v-slot:cell(size)="row">
        <span>{{row.item.size}}</span>
      </template>
    </b-table>
    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
  </b-container>
</template>

<script>
export default {
  name: 'ApiList',
  props: {
    type: {
      type: String,
      default: 'vehicle-capacity'
    },
    title: {
      type: [String, Boolean],
      default: null
    },
    preFilters: {
      type: Array,
      default: () => {
        return []
      }
    },
    prePerPage: {
      type: Number,
      default: 25
    }
  },
  data() {
    return {
      fields: [],
      vehicles: [],
      exclude: this.$appConfig.models[this.type].exclude,
      includes: this.$appConfig.models[this.type].includes || [],
      isBusy: false,
      currentPage: 1,
      perPage: this.prePerPage,
      totalRows: null,
      pageOptions: [10, 25, 50, 100, 500],
      sortBy: 'max_weight',
      sortDesc: false,
      sortDirection: 'desc',
      filters: this.preFilters
    }
  },
  created() {
    this.setFields()
  },
  methods: {
    myProvider(ctx) {
      let params = {
        page: ctx.currentPage - 1,
        limit: ctx.perPage,
        includes: this.includes,
        sort: [
          {
            key: ctx.sortBy || 'id',
            direction: ctx.sortDesc ? 'desc' : 'asc'
          }
        ]
      }
      if (this.filters || this.preFilters) {
        params.filter_groups = [
          {
            filters: this.filters || this.preFilters
          }
        ]
      }

      return this.$http.get(ctx.apiUrl, { params: params })
        .then(data => {
          const items = data.body.data

          // // Here we could override the busy state, setting isBusy to false
          this.totalRows = data.body.pagination.total
          this.$emit('itemsLoaded', items)

          return this.parseData(items)
        })
        .catch(error => {
          console.log(error)
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle busy state in case of error
          return []
        })
    },

    async setVehicleCapacity(data, event) {
      try {
        if (event) {
          const response = await this.$http.post(
            this.$appConfig.api.baseUrl + 'vehicle-type-capacities',
            {
              size_id: data.size.sizeId,
              vehicle_type_id: data.vehicle.id
            }
          )
          data.size[`${data.vehicle.key}_id`] = response.data.id
        } else {
          const id = data.size[`${data.vehicle.key}_id`]
          await this.$http.delete(
            this.$appConfig.api.baseUrl + 'vehicle-type-capacities/' + id
          )
        }
      } catch (e) {
        console.log(e)
      }
    },
    refreshTable(filters) {
      console.log(filters)
      this.filters = filters
      setTimeout(() => {
        this.$root.$emit('bv::refresh::table', this.type)
      }, 100)
    },
    applyFilter() {
      return this.filter
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
      console.log(filteredItems.length)
      this.refreshTable(this.filters)
    },
    setFields() {
      this.isBusy = true
      this.$http.get(
        this.$appConfig.api.baseUrl + 'vehicle-types'
      )
        .then(response => {
          const fields = [{ key: 'size', label: 'Size' }]
          const vehicles = response.data.data
          this.vehicles = vehicles
          for (let i = 0; i < vehicles.length; i++) {
            fields.push({
              key: vehicles[i].name,
              label: vehicles[i].name,
              id: vehicles[i].id
            })
          }
          this.fields = fields
        })
        .catch(error => {
          console.log(error)
        })
      this.isBusy = false
    },
    parseData(data) {
      // We have to loop for the data, and add empty if they do not exist
      const response = []
      const templateVehicles = {}
      for (let i = 0; i < this.vehicles.length; i++) {
        templateVehicles[this.vehicles[i].name] = false
      }

      for (let i = 0; i < data.length; i++) {
        const element = {
          ...templateVehicles,
          size: data[i].name,
          sizeId: data[i].id
        }
        for (
          let vehicleIndex = 0;
          vehicleIndex < data[i].vehicle_type_capacity.length;
          vehicleIndex++
        ) {
          const vehicle = data[i].vehicle_type_capacity[vehicleIndex]
          element[vehicle.vehicle_type.name] = true
          element[vehicle.vehicle_type.name + '_id'] = vehicle.id
        }
        element.full = data[i]
        response.push(element)
      }

      return response
    }
  }
}
</script>
